export const MeasurementErrorText =
  "At least one of measurements should be chosen";
export const RequiredFieldsText = "This field is required";
export const ErrorText = "Please fill in all required fields";
